import React from 'react';
import { useNavigate } from 'react-router-dom';
import { renderHTML } from '../helpers/render-html';

// import homepageBg from '/assets/videos/bg_homepage.mp4';
import WaveEffect from './wave-divider';
import { useLanguage } from '../helpers/language-context';

const ArrowRight = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12 5 19 12 12 19"></polyline>
  </svg>
);


const Header = ({ bgImg = '', back = false, backLink = '/', backText = '', title = '', flip = false, color = '#ffffff', description = false, descriptionText = '', button = false, buttonText = '', buttonLink = '/', onButtonClick = null, bgClassName = '', children }) => {
  const { translations } = useLanguage();
  const navigate = useNavigate();
  const goBack = () => {
    navigate(backLink);
    window.scrollTo(0, 0);
  };

  const hasBgImage = Boolean(bgImg);
  const containerClasses = `relative min-h-[70vh] md:min-h-[100vh] flex items-center justify-center${hasBgImage ? ' bg-cover bg-center bg-no-repeat' : ' bg-[#28357B]'} ${bgClassName}`;

  return (
    <section
      className={`overflow-hidden ${containerClasses}`}
      style={hasBgImage ? { backgroundImage: `url(${bgImg})` } : undefined}
    >

      {/* <video
        autoPlay
        muted
        loop
        className="absolute z-0 w-auto min-w-full min-h-full max-w-none object-cover"
      >
        <source src="/assets/videos/bg_homepage.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video> */}

      {/* Content overlay */}
      <div className={`absolute inset-0 z-10 flex items-center justify-center md:justify-start w-full h-full  ${hasBgImage ? ' bg-black bg-opacity-20' : ''}`}>
        <div className="text-white text-center md:text-start animate-fade-in">
          <div className="space-y-2 px-6 md:px-24 animate-fade-in">
            {back && (
              <div className="flex gap-2 text-white hover:text-gray-300 mb-6 md:mb-10 cursor-pointer" onClick={goBack}>
                <div className="rotate-180">
                  <ArrowRight />
                </div>
                <div
                  className="text-sm font-medium"
                >
                  {translations.button.backTo + backText}
                </div>
              </div>
            )}
            <div className="space-y-4 md:space-y-8 pt-16 md:pt-0">
              <h1 className="text-4xl md:text-7xl lg:text-8xl font-bold md:font-light leading-tight drop-shadow-md" dangerouslySetInnerHTML={renderHTML(title)} />
               {description && (
                <div className="text-base md:text-lg text-white drop-shadow-sm font-medium">
                  {descriptionText}
                </div>
              )}
              {button && (
                <div className="flex justify-center md:justify-start">
                  <button
                    onClick={() => {
                      if (onButtonClick) {
                        onButtonClick();
                      } else {
                        navigate(buttonLink);
                      }
                    }}
                    className="bg-white text-[#28357B] px-6 py-4 rounded-full text-xs md:text-[14px] font-semibold flex justify-center md:justify-start"
                  >
                    {buttonText}
                  </button>
                </div>
              )}
              {/* Bottom Slot */}
              {children && (
                <div className="mt-8">
                  {children}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <WaveEffect color={color} flip={flip} />
    </section>
  );
};

export default Header;
